import type { GradeMiddle, Revision } from '@mathflat/domain/SchoolSystem'
import { difference, flattenDeep } from 'lodash-es'
import { action, computed, makeObservable, observable } from 'mobx'

import type { ByPracticeCoreOptions } from '@/page/MakeWorksheet/MakeWorksheetBy/ByPracticeTest/types/types'

import { DTO } from '../DTO'

// 학습지만들기 1단계 - 수능 모의고사 - 왼쪽 모의고사 찾는 필터
export class FindPracticeTestFilter extends DTO implements ByPracticeCoreOptions {
  gradeList: GradeMiddle[]
  yearList: number[]
  monthList: number[]
  revision: Revision

  // 지난 조회때 사용되었던 옵션 값들
  private prevGradeList: GradeMiddle[] = []
  private prevYearList: number[] = []
  private prevMonthList: number[] = []

  constructor(coreOptions: ByPracticeCoreOptions) {
    super()
    this.gradeList = [...coreOptions.gradeList]
    this.yearList = [...coreOptions.yearList]
    this.monthList = [...coreOptions.monthList]
    this.revision = coreOptions.revision

    makeObservable(this, {
      gradeList: observable,
      yearList: observable,
      monthList: observable,
      revision: observable,
      params: computed,
      deselectedIds: computed,
      currentSelectedIds: computed,
      prevSelectedIds: computed,
      saveOptions: action,
      makePracticeTestIdByOption: action,
    })
  }

  get params(): ByPracticeCoreOptions {
    return {
      gradeList: this.gradeList,
      yearList: this.yearList,
      monthList: this.monthList,
      revision: this.revision,
    }
  }

  // 기존 선택된 아이디 - 현재 선택된 아이디 = 선택해제된 아이디
  get deselectedIds() {
    return difference(this.prevSelectedIds, this.currentSelectedIds)
  }
  get currentSelectedIds() {
    return this.makePracticeTestIdByOption(this.params)
  }
  get prevSelectedIds() {
    return this.makePracticeTestIdByOption({
      gradeList: this.prevGradeList,
      monthList: this.prevMonthList,
      yearList: this.prevYearList,
    })
  }

  saveOptions = () => {
    this.prevGradeList = this.gradeList
    this.prevMonthList = this.monthList
    this.prevYearList = this.yearList
  }

  // PracticeTest['id']의 형태로 option을 조합하는 함수
  makePracticeTestIdByOption = ({ yearList, monthList, gradeList }) => {
    return flattenDeep<string>(
      yearList.map((year) =>
        monthList.map((month) => gradeList.map((grade) => `${year}-${month}-${grade}`)),
      ),
    ) as `${string}-${string}-${string}`[]
  }
}
